import { LegalPage } from "../components/legal/LegalPage";
import { DISCLAIMER_SECTIONS, SHORT_DISCLAIMER } from "../constants/disclaimer";
import { PRIVACY, TERMS } from "../constants/legal";

export const DisclaimerPage = () => <LegalPage slug="disclaimer" title="Legal Disclaimer" summary={SHORT_DISCLAIMER} sections={DISCLAIMER_SECTIONS} />;
export const TermsPage = () => <LegalPage slug="terms" {...TERMS} />;
export const PrivacyPage = () => <LegalPage slug="privacy" {...PRIVACY} />;
